import { render, staticRenderFns } from "./AppCreateForm.vue?vue&type=template&id=6db47f72"
import script from "./AppCreateForm.vue?vue&type=script&lang=js"
export * from "./AppCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports